import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { BoxProps, DialogProps } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  IconWrapper,
  SubTitle,
  CancelButton,
  SubmitButton,
} from './styled';

interface ConfirmDialogProps extends DialogProps {
  onClose?: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  subTitle?: string;
  children?: ReactNode;
  dialogSx?: BoxProps['sx'];
  titleSx?: BoxProps['sx'];
  contentSx?: BoxProps['sx'];
  withLogo?: boolean;
  isContentOverflow?: boolean;
  submitLabel?: string;
  cancelLabel?: string;
}

export function NewConfirmDialog({
  title,
  onClose,
  onConfirm,
  open = true,
  isLoading,
  subTitle,
  dialogSx,
  titleSx,
  children,
  isContentOverflow,
  contentSx,
  submitLabel,
  cancelLabel,
  ...otherProps
}: ConfirmDialogProps): ReactElement {
  const { t } = useTranslation();
  return (
    <Dialog open={open} sx={dialogSx} {...otherProps}>
      <IconWrapper>
        <WarningAmberRoundedIcon sx={{ fontSize: 48, color: '#ef4444' }} />
      </IconWrapper>
      {title && <DialogTitle sx={titleSx}>{title}</DialogTitle>}
      {subTitle && <SubTitle>{subTitle}</SubTitle>}
      {children && (
        <DialogContent sx={contentSx} isContentOverflow={isContentOverflow}>
          {children}
        </DialogContent>
      )}
      <DialogActions>
        {onClose && (
          <CancelButton variant="outlined" onClick={onClose}>
            {cancelLabel || t('resources.documentCategories.removeModal.buttons.cancel')}
          </CancelButton>
        )}
        <SubmitButton variant="contained" onClick={onConfirm} disabled={isLoading}>
          {submitLabel || t('resources.documentCategories.removeModal.buttons.remove')}
        </SubmitButton>
      </DialogActions>
    </Dialog>
  );
}
